import $ from 'jquery';

const $complaintsContact = $('.find-an-office');

$complaintsContact.each((i, el) => {
  const $el = $(el);
  const $statePicker = $el.find('.find-an-office-state-picker');
  const $items = $el.find('.find-an-office-item');

  function switchLocations() {
    const selectedState = $statePicker.val();

    $items.each((itemIndex, item) => {
      const $item = $(item);
      const state = $item.attr('data-state');
      if (state === selectedState) {
        $item.addClass('is-current');
      } else {
        $item.removeClass('is-current');
      }
    });
  }

  $statePicker.on('change', e => {
    e.preventDefault();
    switchLocations();
  });

  switchLocations();
});
